module.exports = __webpack_public_path__ + "img/forest-cover-small.02603cb5.svg";